import { useEffect } from "react";
import { Icon } from "@iconify/react";
import $ from "jquery";

const SuccessAlert = ({ message, onClose }) => {
  useEffect(() => {
    if (message) {
      $(".success-alert").stop().fadeIn(400).css({ right: "20px" });

      const timer = setTimeout(() => {
        $(".success-alert").fadeOut(400, onClose);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  return (
    <div
      className="success-alert position-fixed top-0 end-0 mt-3 me-3"
      style={{
        zIndex: 1050,
        minWidth: "300px",
        display: "none",
        position: "fixed",
        right: "-100px",
      }}
    >
      <div
        className="alert alert-success bg-success-100 text-success-600 border-success-600 
                   border-start-width-4-px px-24 py-13 fw-semibold text-lg radius-4 
                   d-flex align-items-center justify-content-between"
        role="alert"
      >
        <div className="d-flex align-items-center gap-2">
          <Icon icon="akar-icons:double-check" className="icon text-xl" />
          {message}
        </div>
        <button
          className="remove-button text-success-600 text-xxl line-height-1"
          onClick={() => $(".success-alert").fadeOut(400, onClose)}
        >
          <Icon icon="iconamoon:sign-times-light" className="icon" />
        </button>
      </div>
    </div>
  );
};

export default SuccessAlert;
